export default {
  'ההסתדרות הציונית העולמית - החטיבה להתישבות': ['ההסתדרות הציונית העולמית - החטיבה להתישבות'],
  'המשרד לאזרחים ותיקים': ['המשרד לאזרחים ותיקים'],
  'המשרד לבטחון פנים': ['המשרד לבטחון פנים', 'המשרד לביטחון פנים'],
  'המשרד להגנת הסביבה': ['המשרד להגנת הסביבה'],
  'המשרד לירושלים והתפוצות': ['המשרד לירושלים והתפוצות'],
  'המשרד לעניני מודיעין': ['המשרד לעניני מודיעין'],
  'המשרד לפיתוח הנגב והגליל': ['המשרד לפיתוח הנגב והגליל'],
  'המשרד לקליטת העליה': ['המשרד לקליטת העליה'],
  'המשרד לשירותי דת': ['המשרד לשירותי דת'],
  'המשרד לשיתוף פעולה אזורי': ['המשרד לשיתוף פעולה אזורי'],
  'הרשות לשירותים ציבוריים - חשמל': ['הרשות לשירותים ציבוריים - חשמל'],
  'משרד האוצר': ['משרד האוצר'],
  'משרד הבינוי': ['משרד הבינוי'],
  'משרד הבריאות': ['משרד הבריאות'],
  'משרד החוץ': ['משרד החוץ'],
  'משרד החינוך': ['משרד החינוך'],
  'משרד החקלאות ופיתוח הכפר': ['משרד החקלאות ופיתוח הכפר'],
  'משרד הכלכלה': ['משרד הכלכלה'],
  'משרד המדע התרבות והספורט': ['משרד המדע התרבות והספורט'],
  'משרד המשפטים': ['משרד המשפטים'],
  'משרד הפנים': ['משרד הפנים'],
  'משרד הרווחה': ['משרד הרווחה'],
  'משרד התחבורה והבטיחות בדרכים': ['משרד התחבורה והבטיחות בדרכים'],
  'משרד התיירות': ['משרד התיירות'],
  'משרד התקשורת': ['משרד התקשורת'],
  'משרד התשתיות הלאומיות, האנרגיה והמים': ['משרד התשתיות הלאומיות, האנרגיה והמים'],
  'משרד ראש הממשלה': ['משרד ראש הממשלה'],
  'מתאם פעולות הממשלה בשטחים': ['מתאם פעולות הממשלה בשטחים'],
  'רשות מקרקעי ישראל': ['רשות מקרקעי ישראל'],
};



// WEBPACK FOOTER //
// ./app/scripts/Hasadna/oBudget/Pages/Exemptions/parentMinistriesVariants.js